export default __webpack_public_path__ + "static/media/loader4.0da201ce.jpg";